import {hot} from 'react-hot-loader/root';
import React from 'react';
import {Route} from 'react-router-dom';
import {ApolloProvider} from '@apollo/react-hooks';
import {
    // FIXME review this
    // ApolloProvider,
    ApolloClient,
    NormalizedCacheObject,
} from '@apollo/client';
import PageContainer from '../../containers/PageContainer/PageContainer';

interface AppOptions {
    client: ApolloClient<NormalizedCacheObject>;
    homeRoute: string;
    redirects: Record<string, unknown>;
    systemData: Record<string, unknown>;
    footerData: Record<string, unknown>;
}

const App = ({
    client,
    homeRoute,
    redirects,
    systemData,
    footerData,
}: AppOptions) => (
    // @ts-ignore @apollo/client/react/components/Query is deprecated and ts check fails on last version
    <ApolloProvider client={client}>
        <Route
            path={`${homeRoute}/:slug*`}
            render={(props) => (
                <PageContainer
                    {...props}
                    client={client}
                    homeRoute={homeRoute}
                    redirects={redirects}
                    systemData={systemData}
                    footerData={footerData}
                />
            )}
        />
    </ApolloProvider>
);

// @ts-ignore review warning
export default hot(App);
